import {
  Box,
  InputLabel,
  Stack,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import useSaveUserConfig from 'hooks/data-saving/useSaveUserConfig';
import useAuth from 'hooks/useAuth';
import { useNavigate } from 'react-router';
import { RootState, useSelector } from 'store';
import ClearReduxPersistStore from 'utils/clearReduxPersistStore';

// ==============================|| HEADER PROFILE OPTIONS ||============================== //

const ProfileTab = () => {
  const { user } = useAuth();
  const { viewRoute } = useSelector((state: RootState) => state.config.userConfig) || {};
  const saveUserConfig = useSaveUserConfig();
  const navigate = useNavigate();

  const handleViewChange = (_: any, newView: string | null) => {
    navigate('/');
    saveUserConfig({ viewRoute: newView });
  };

  return (
    <Stack spacing={2}>
      {(user?.accountTypes?.includes('Staff') || user?.isReducedAccess01) && (
        <Box sx={{ m: 2 }}>
          <InputLabel>View As:</InputLabel>
          <ToggleButtonGroup
            exclusive
            sx={{ display: 'flex' }}
            size="small"
            value={viewRoute}
            onChange={handleViewChange}
          >
            <ToggleButton value="Staff" sx={{ flex: 1 }}>
              Staff
            </ToggleButton>
            <ToggleButton value="Talent" sx={{ flex: 1 }}>
              Talent
            </ToggleButton>
            <ToggleButton value="Client" sx={{ flex: 1 }}>
              Client
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}
      <ClearReduxPersistStore />

      {/* <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemButton>
          <ListItemIcon>
            <EditOutlined />
          </ListItemIcon>
          <ListItemText primary="Test Action" />
        </ListItemButton>
      </List> */}
    </Stack>
  );
};

export default ProfileTab;
